import { ECompetitionLevel } from '../../../../repositories/auction/entities/AnnouncementsBets/CompetitionPromotionTypeInfo';
import { ECompetitorsLevel } from '../../../../reducers/v2';

export function mapCompetitionLevel(level: ECompetitionLevel): ECompetitorsLevel {
  switch (level) {
    case ECompetitionLevel.Low:
      return ECompetitorsLevel.low;
    case ECompetitionLevel.Middle:
      return ECompetitorsLevel.medium;
    case ECompetitionLevel.High:
      return ECompetitorsLevel.high;
    default:
      throw new Error(`Unknown competition level: ${level}`);
  }
}
